var _path, _path2, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcSuggestBlue = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.28099 16.3602C2.36966 16.9613 2.93261 17.437 3.77688 17.5628C5.1095 17.7614 7.6216 18 12 18C16.3784 18 18.8905 17.7614 20.2232 17.5628C21.0674 17.437 21.6304 16.9613 21.719 16.3602C21.8505 15.4691 22 13.8329 22 11C22 8.16714 21.8505 6.53092 21.719 5.63976C21.6304 5.03872 21.0674 4.56297 20.2231 4.43715C18.8905 4.23857 16.3784 4 12 4C7.6216 4 5.1095 4.23857 3.77688 4.43715C2.93261 4.56297 2.36966 5.03872 2.28099 5.63976C2.14952 6.53092 2 8.16714 2 11C2 13.8329 2.14952 15.4691 2.28099 16.3602Z",
    fill: "#3C6FF5",
    fillOpacity: 0.32
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.93189 19.8483L6 17H13L5.61296 20.4763C5.20701 20.6673 4.77436 20.2684 4.93189 19.8483Z",
    fill: "#3C6FF5",
    fillOpacity: 0.32
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 8,
    width: 13,
    height: 2,
    rx: 1,
    fill: "#3C6FF5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 12,
    width: 9,
    height: 2,
    rx: 1,
    fill: "#3C6FF5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcSuggestBlue);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_suggest_blue.90ca90b9817461a17fe75d253a82eef3.svg";